import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Switch } from 'react-router-dom';
import EditableRoute from '@components/EditableRoute';

import { AnalysisRoutes } from './constants';
import AnalysisPageWrapper from './components/PageWrapper';

const Loading = () => <div />;

const AnalysisMarketAreaSearch = Loadable({
  loader: () => import('./pages/marketAreaSearch'),
  loading: Loading,
});

const AnalysisMarketAreaSummary = Loadable({
  loader: () => import('./pages/marketAreaSummary'),
  loading: Loading,
});

const AnalysisDefaults = Loadable({
  loader: () => import('./pages/analysisDefaults'),
  loading: Loading,
});

const AnalysisEquityComparables = Loadable({
  loader: () => import('./pages/equityComparables'),
  loading: Loading,
});

const AnalysisSalesComparables = Loadable({
  loader: () => import('./pages/salesComparables'),
  loading: Loading,
});

const AnalysisSmartLists = Loadable({
  loader: () => import('../appraisal/pages/smartListLauncher'),
  loading: Loading,
});

const AnalysisMassUpdate = Loadable({
  loader: () => import('./pages/massUpdate'),
  loading: Loading,
});

const AnalysisStrata = Loadable({
  loader: () => import('./pages/strata'),
  loading: Loading,
});

const AnalysisStrataRuns = Loadable({
  loader: () => import('./pages/strataRuns'),
  loading: Loading,
});

const AnalysisStratificationRuns = Loadable({
  loader: () => import('./pages/stratifications'),
  loading: Loading,
});

const SalesAnalysisTransitions = Loadable({
  loader: () => import('./pages/salesAnalysisTransitions'),
  loading: Loading,
});

const Routes = props => (
  <AnalysisPageWrapper {...props}>
    <Switch>
      <EditableRoute
        component={AnalysisMarketAreaSearch}
        exact
        path={AnalysisRoutes.AnalysisMarketAreaSearch}
      />
      <EditableRoute
        component={AnalysisMarketAreaSummary}
        exact
        path={AnalysisRoutes.AnalysisMarketAreaSummary}
      />
      <EditableRoute
        component={AnalysisDefaults}
        exact
        path={AnalysisRoutes.AnalysisDefaults}
      />
      <EditableRoute
        component={AnalysisEquityComparables}
        exact
        path={AnalysisRoutes.AnalysisEquityComparables}
        key={Date.now()}
      />
      <EditableRoute
        component={AnalysisSalesComparables}
        exact
        path={AnalysisRoutes.AnalysisSalesComparables}
        key={Date.now()}
      />
      <EditableRoute
        component={AnalysisSmartLists}
        exact
        path={AnalysisRoutes.AnalysisSmartLists}
      />
      <EditableRoute
        component={AnalysisMassUpdate}
        exact
        path={AnalysisRoutes.AnalysisMassUpdate}
      />
      <EditableRoute
        component={AnalysisStrata}
        exact
        path={AnalysisRoutes.AnalysisStrata}
      />
      <EditableRoute
        component={AnalysisStrataRuns}
        exact
        path={AnalysisRoutes.AnalysisStrataRuns}
      />
      <EditableRoute
        component={AnalysisStratificationRuns}
        exact
        path={AnalysisRoutes.AnalysisStratifications}
      />
      <EditableRoute
        component={SalesAnalysisTransitions}
        exact
        path={AnalysisRoutes.SalesAnalysisTransitions}
      />
      <Redirect to={AnalysisRoutes.AnalysisMarketAreaSearch} />
    </Switch>
  </AnalysisPageWrapper>
);

export default Routes;
